
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import GameHero from '../components/pokemon-clicker-2/GameHero';
import GameDescription from '../components/pokemon-clicker-2/GameDescription';
import GameFeatures from '../components/pokemon-clicker-2/GameFeatures';
import GameGuide from '../components/pokemon-clicker-2/GameGuide';
import GameFAQ from '../components/pokemon-clicker-2/GameFAQ';
import GameStrategy from '../components/pokemon-clicker-2/GameStrategy';
import GameEvolution from '../components/pokemon-clicker-2/GameEvolution';
import GameCommunity from '../components/pokemon-clicker-2/GameCommunity';
import GameHistory from '../components/pokemon-clicker-2/GameHistory';
import GameControls from '../components/pokemon-clicker-2/GameControls';

const PokemonClicker2 = () => {
  const intl = useIntl();

  return (
    <>
      <Helmet>
        <title>Pokemon Clicker 2 - Free Online Pokemon Clicking Game</title>
        <meta name="description" content="Play Pokemon Clicker 2 free online, the best Pokemon idle clicker game. Catch, evolve, and collect Pokemon in this addictive clicking adventure!" />
        <meta name="keywords" content="pokemon clicker 2, pokemon clicking game, free online pokemon game, idle clicker pokemon, catch pokemon online" />
        <link rel="canonical" href="https://www.pokedle.cc/pokemon-clicker-2" />
      </Helmet>

      <div className="bg-gradient-to-b from-blue-900 via-indigo-800 to-purple-900 min-h-screen">
        <GameHero />
        
        {/* Game iframe section */}
        <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
            <div className="p-4 sm:p-6 bg-gradient-to-r from-blue-500 to-purple-600">
              <h2 className="text-2xl font-bold text-white text-center">Play Pokemon Clicker 2 Now!</h2>
              <p className="text-white text-center mt-2">No download required - play directly in your browser!</p>
            </div>
            <div className="w-full aspect-[16/9] h-[600px] relative">
              <iframe 
                src="https://scratch.mit.edu/projects/13878266/embed" 
                className="absolute top-0 left-0 w-full h-full"
                frameBorder="0" 
                allowFullScreen
                allow="gamepad *;"
                title="Pokemon Clicker 2 Game"
              ></iframe>
            </div>
          </div>
        </section>

        <GameDescription />
        <GameFeatures />
        <GameGuide />
        <GameControls />
        <GameEvolution />
        <GameStrategy />
        <GameHistory />
        <GameCommunity />
        <GameFAQ />
      </div>
    </>
  );
};

export default PokemonClicker2;
